import { getData } from "app/data";
import { Fragment, useCallback, useEffect, useRef, useState } from "react";
import classes from "./BlogPage.module.css";
import SubscribeForm from "components/Blog/SubscribeForm/SubscribeForm";
import BlogCardList from "components/Blog/BlogCard/BlogCardList";
import WaitingFor from "components/Banner/WaitingFor";
import { useSelector } from "react-redux";
import BackgroundItems from "../../../BackGround/BackgroundItems";
import { Spinner } from "react-bootstrap";

const Index = (props) => {
  const [isLoadingPosts, setIsLoadingPosts] = useState(false);
  // prevent multiple clicks
  const isOnProcess = useRef(false);

  // setup data
  const lan = useSelector((state) => state?.settings?.lan ?? "en");
  const blogPostList = props.blogPostList[lan];
  const pageIndex = props.pageIndex[lan];
  const hasNextBlogPosts = props.hasNextBlogPosts[lan];
  const tagId = props.tagIds[lan];
  const { loadBlogPostList, incrementPageIndex, setHasNextBlogPosts } = props;

  const loadPosts = useCallback(() => {
    if (isOnProcess.current || !tagId) {
      return;
    }
    isOnProcess.current = true;

    setIsLoadingPosts(true);

    const asyncLoadBlogPostList = async () => {
      try {
        // load posts
        await loadBlogPostList(lan, pageIndex, tagId);
        // update page index
        incrementPageIndex(lan);
      } catch (err) {
        // error if no more posts
        setHasNextBlogPosts(lan, false);
      } finally {
        setIsLoadingPosts(false);
        isOnProcess.current = false;
      }
    };

    asyncLoadBlogPostList();
  }, [incrementPageIndex, setHasNextBlogPosts, pageIndex, lan, tagId]);

  useEffect(() => {
    if (blogPostList.length !== 0) {
      return;
    }

    loadPosts();
  }, [lan, tagId]);

  return (
    <Fragment>
      <section className={classes["hero-section"]}>
        <BackgroundItems />
        <div className={classes["hero__texts"]}>
          <h2 className={classes["hero__heading"]}>
            {getData("blogListData").header.title}
          </h2>
          <p className={classes["hero__text"]}>
            {getData("blogListData").header.text}
          </p>
        </div>
      </section>
      <section className={classes["blog-card-section"]}>
        {blogPostList && blogPostList.length > 0 ? (
          <BlogCardList blogList={blogPostList} />
        ) : (
          <Spinner
            animation="border"
            role="status"
            className={classes["spinner"]}
          />
        )}
      </section>
      <section className={classes["actions-section"]}>
        {hasNextBlogPosts && (
          <button className={classes["load-more-button"]} onClick={loadPosts}>
            {isLoadingPosts ? "Loading..." : "Load more"}
          </button>
        )}
      </section>
      <section className={classes["subscribe-section"]}>
        <SubscribeForm />
      </section>
      <WaitingFor />
    </Fragment>
  );
};

export default Index;
